module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-container"
  }, [_c('router-view', {
    attrs: {
      "paymentdetails2": _vm.paymentdetails2
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3657b289"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Paymentdetails2/Paymentdetails2.vue
// module id = 1331
// module chunks = 0